import React from "react";

import { CssBaseline, Grid, Container, Typography } from "@material-ui/core";

import Formulario from "../../precalificar/formularioRow";

//styles
import useStyles from "./styles";

export default function Parametros(props) {
  const classes = useStyles();

  return (
    <div className={classes.root} id="Precalificar">
      <CssBaseline />

      <main className={classes.content}>
        <Container maxWidth="md" className={classes.container}>
          <CssBaseline />
          <Grid container direction="column" justifyContent="space-evenly">
            <Typography
              className={classes.TituloForm}
              variant="h4"
              color="secondary"
              align="left"
              gutterBottom
            >
              Precalificación #{props.id}
            </Typography>

            <Formulario id={props.id} />
          </Grid>
        </Container>
      </main>
    </div>
  );
}
